// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2ti5c","footer":"ModalInfo_footer__C08dd"};